import React from 'react';

/**
 * ActionBadge Component
 * 
 * Displays audit log action types as styled badges using OM Design System omk-tag component.
 * Replaces the legacy inline span element with consistent design system styling.
 * 
 * @param {Object} props - Component props
 * @param {string} props.action - The action type (e.g., 'CLAIM_CREATED', 'CLAIM_APPROVED')
 * @param {string} [props.className] - Additional CSS classes
 */
const ActionBadge = ({ action, className = '' }) => {
  /**
   * Map action types to OM Design System tag types
   * Based on the original color mapping:
   * - Blue (bg-blue-100 text-blue-800) → information
   * - Green (bg-green-100 text-green-800) → positive
   * - Red (bg-red-100 text-red-800) → danger
   * - Yellow (bg-yellow-100 text-yellow-800) → warning
   * - Purple (bg-purple-100 text-purple-800) → information
   * - Gray (bg-gray-100 text-gray-800) → default/neutral
   */
  const getTagType = (action) => {
    switch (action) {
      case 'CLAIM_CREATED':
        return 'information'; // Blue → information
      case 'CLAIM_APPROVED':
        return 'positive'; // Green → positive
      case 'CLAIM_REJECTED':
        return 'danger'; // Red → danger
      case 'STATUS_CHANGE':
        return 'warning'; // Yellow → warning
      case 'DOCUMENT_UPLOAD':
        return 'information'; // Purple → information
      case 'SLA_BREACH':
        return 'danger'; // Red → danger
      case 'SLA_WARNING':
        return 'warning'; // Orange → warning
      case 'SLA_STARTED':
        return 'information'; // Default to information
      case 'CLAIM_UPDATED':
        return 'information'; // Default to information
      default:
        return 'neutral'; // Gray → neutral/default
    }
  };

  /**
   * Format action text for display
   * Converts underscore-separated actions to readable format
   */
  const formatActionText = (action) => {
    return action.replace(/_/g, ' ');
  };

  if (!action) {
    return null;
  }

  return (
    <omk-tag
      type={getTagType(action)}
      className={className}
    >
      {formatActionText(action)}
    </omk-tag>
  );
};

export default ActionBadge;